import styled from 'styled-components'
export const HeaderWrapper: any = styled.div`
  width: 100%;
  height: 100%;
  /* box-shadow: 0 1px 4px rgb(0 21 41 / 8%); */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  .h_left {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .h_right {
    height: 100%;
    display: flex;
    align-items: center;
  }
`
